export const CONVERSION_TOOL_MAPPING_EDIT_RESET = 'CONVERSION_TOOL_MAPPING_EDIT_RESET';

export const CONVERSION_TOOL_MAPPING_EDIT_START = 'CONVERSION_TOOL_MAPPING_EDIT_START';
export const CONVERSION_TOOL_MAPPING_EDIT_SUCCESS = 'CONVERSION_TOOL_MAPPING_EDIT_SUCCESS';
export const CONVERSION_TOOL_MAPPING_EDIT_FAILURE = 'CONVERSION_TOOL_MAPPING_EDIT_FAILURE';

export const CONVERSION_TOOL_MAPPING_FETCH_START = 'CONVERSION_TOOL_MAPPING_FETCH_START';
export const CONVERSION_TOOL_MAPPING_FETCH_SUCCESS = 'CONVERSION_TOOL_MAPPING_FETCH_SUCCESS';
export const CONVERSION_TOOL_MAPPING_FETCH_FAILURE = 'CONVERSION_TOOL_MAPPING_FETCH_FAILURE';
